export const Arrays = function(arr) {
  if (arr != undefined && arr.length > 0 && Array.isArray(arr)) {
		return true
	} else {
		return false
	}
}